import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.loom',
		defaultMessage: 'Loom',
		description: 'The link label for Loom',
	},
});
